import { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// ** MUI Imports
import {
  Button,
  Box,
  Typography,
  Divider,
  CircularProgress,
  Backdrop,
} from "@mui/material";

import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import MuiTimeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";
// ** Util Imports
import { hexToRGBA } from "../../../components/utils/hex-to-rgba";

//import AddServiceDialog from "./component/AddService";
// import DateRangeCalendar from "../../Customers/component/DateRangeCalendar";

import AttachmentUploadDialog from "components/AttachmentUpload";

// ** Icon Imports
import Icon from "../../../components/icon";

import AddIcon from "@mui/icons-material/Add";

// ** Custom Components Imports

import OptionsMenu from "../../../components/option-menu";

// ** Styled Component
// ** Third Party Components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from 'date-fns';
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";


// import AssignToDialog from "./component/AssignTo";
import PreAttachment from "../component/PreAttachment";
import { DownloadAttachments } from "components/logic/DownloadAttachments";


import _ from 'lodash';

import VideoPlaceholderIcon from 'images/video_placeholder.png';
import CSV_PlaceholderIcon from 'images/Attachment_Icons/CSV__PlaceholderIcon.png';
import PDF_PlaceholderIcon from 'images/Attachment_Icons/PDF_PlaceholderIcon.png';
import DOCX_PlaceholderIcon from 'images/Attachment_Icons/DOCX__PlaceholderIcon.png';
import XLSX_PlaceholderIcon from 'images/Attachment_Icons/XLSX__PlaceholderIcon.png';
import FilePlaceholder from 'images/image_placeholder.png';
import { dev_baseUrl } from "utils/var";

// Styled Timeline component
const Timeline = styled(MuiTimeline)({
  "& .MuiTimelineItem-root": {
    width: "100%",
    "&:before": {
      display: "none",
    },
  },
});


const AttachmentsComponent = ({
  rules,
  request,
  requestType,
  handleOpenUnsavedChangesDlg,
  theme,
  loading,
  openUploadDlg2,
  setOpenUploadDlg2,
  AttachmentProps,
}) => {

  const MySwal = withReactContent(Swal);

  const [attachments, setAttachments] = useState([]);
  const [isAttachmentsLoading, setIsAttachmentsLoading] = useState(false);
  const [groupedAttachments, setGroupedAttachments] = useState({});
  // const [openUploadDlg2, setOpenUploadDlg2] = useState(false);
  const [uploadFiles2, setUploadFiles2] = useState([]);
  const [files2, setFiles2] = useState([])
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(new Date);
  const [btnLoader, setBtnLoader] = useState(false);
  const [thumbnails, setThumbnails] = useState({});
  const [isDownloading, setIsDownloading] = useState(false);

  const navigate = useNavigate();

  const handleOpenUploadDlg2 = () => {
    setOpenUploadDlg2(true);
  }

  const fetchAttachments = async () => {
    if (!request.requestID) return;
  
    try {
      setIsAttachmentsLoading(true);
      const token = localStorage.getItem('jwtToken');
      const response = await fetch(`${dev_baseUrl}/Media/getmedia/Attachment/Request/${request.requestID}/0`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      const data = await response.json();
  
      if (response.ok && !data.isError) {
        setAttachments(data.result);
      } else {
        console.error("Failed to fetch attachments:", data.message);
      }
    } catch (error) {
      console.error("Error fetching attachments:", error);
    } finally {
      setIsAttachmentsLoading(false);
    }
  };
  
  useEffect(() => {
    if (request.requestID) {
      fetchAttachments();
    }
  }, [request.requestID]);
  
  useEffect(() => {
    const grouped = attachments.reduce((acc, attachment) => {
      const parsedDate = new Date(attachment.createDate);
  
      // Check if the date is valid
      if (!isNaN(parsedDate.getTime())) {
        const dateKey = format(parsedDate, 'MMMM dd, yyyy'); // Group by date
  
        if (!acc[dateKey]) acc[dateKey] = [];
        acc[dateKey].push(attachment);
      }
      return acc;
    }, {});
  
    setGroupedAttachments(grouped);
  }, [attachments]); // Re-run grouping when attachments change

    const getFileType = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    if (['mp4', 'mov', 'avi', 'webm', 'mkv'].includes(ext)) return 'video';
    if (['txt', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'csv', 'json', 'xml'].includes(ext)) return 'text';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'].includes(ext)) return 'image';
    return 'other';
  };

  const getAttachmentThumbnail = async (requestID, filename) => {
    const fileExtension = filename.split('.').pop()?.toLowerCase();

    const fileType = getFileType(filename)
    if(fileType === 'video'){
      return VideoPlaceholderIcon;
    }else if (fileType === 'text'){
      if(fileExtension === 'csv'){
        return CSV_PlaceholderIcon
      }else if(fileExtension === 'pdf'){
        return PDF_PlaceholderIcon
      }else if(fileExtension === 'doc' || fileExtension === 'docx'){
        return DOCX_PlaceholderIcon
      }else if(fileExtension === 'xls' || fileExtension === 'xlsx'){
        return XLSX_PlaceholderIcon
      }
    }else if(fileType === 'image'){
      try {
        const blob = await DownloadAttachments('Attachment','Request', requestID, filename, navigate);
        const imgurl = URL.createObjectURL(blob);
  
        return imgurl
      }catch (error){
        console.error("Failed to fetch media thumbnail", error)
      }
    }else{
      return FilePlaceholder
    }
  };

  useEffect(() => {
    const fetchThumbnails = async () => {
      const newThumbnails = {};
      
      for (const date in groupedAttachments) {
        for (const attachment of groupedAttachments[date]) {
          const imgUrl = await getAttachmentThumbnail(request?.requestID, attachment.fileName);
          newThumbnails[attachment.fileName] = imgUrl;
        }
      }
  
      setThumbnails(newThumbnails);
    };
  
    fetchThumbnails();
  }, [groupedAttachments]);

  const downloadAttachment = async (requestID, fileName) => {
    // Prevent duplicate downloads
    if (isDownloading) {
      console.log('Download already in progress, ignoring duplicate call');
      return;
    }

    try {
      setIsDownloading(true);
      console.log(`Starting download for: ${fileName}`);
      
      // Use existing DownloadAttachments helper (same one used for previews)
      const result = await DownloadAttachments('Attachment', 'Request', requestID, fileName, navigate);
      
      // Check if result is an error object (has 'form' property)
      if (!result || result.form) {
        toast.error(result?.form || 'Failed to download the file', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
            theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
        });
        return;
      }
      
      // Result is a valid blob - create download link
      const link = document.createElement('a');
      link.href = URL.createObjectURL(result);
      link.download = fileName;
      link.click();
      
      // Clean up blob URL to prevent memory leaks
      setTimeout(() => URL.revokeObjectURL(link.href), 100);
      
      toast.success(`${fileName} downloaded successfully.`, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
          theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
    } catch (error) {
      console.error('Download failed:', error);
      toast.error('An error occurred while downloading. Please try again.', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
         theme: "light",
              style: {
                fontFamily: '"DM Sans", sans-serif',
                fontSize: '15px',
              },
      });
    } finally {
      // Reset the download flag after a short delay to allow next download
      setTimeout(() => setIsDownloading(false), 500);
    }
  };  

  const getFileIcon = (fileName) => {
    let icon;
    if (fileName.includes('.xlsx')) {
      icon = "../../images/xlsx.png";
    } else if (fileName.includes('.csv')) {
      icon = "../../images/csv.png";
    } else if (fileName.includes('jpg')) {
      icon = "../../images/image_placeholder.png"; // Placeholder for images
    } else if (fileName.includes('jpeg')) {
      icon = "../../images/image_placeholder.png"; // Placeholder for images
    } else if (fileName.includes('png') || fileName.includes('PNG')) {
      icon = "../../images/image_placeholder.png"; // Placeholder for images
    } else if (fileName.includes('.pdf')) {
      icon = "../../images/pdf_placeholder.png"; // Placeholder for PDFs
    } else {
      icon = "../../images/placeholder.png"; // Optional: a default placeholder for unsupported types
    }
    return icon;
  };

  const handleCloseUploadDlg2 = () => {
    if(uploadFiles2.length > 0){
       handleOpenUnsavedChangesDlg();

     }else{
        setFiles2([]);
        setUploadFiles2([]);
        setOpenUploadDlg2(false); 
     }  
  };

return (
  <>
    <Box
      sx={{
        display: "flex",
        justifyContent: { xs: "center", sm: "flex-end" },
        alignItems: "center",
        gap: 2,
      }}
    >
      {/* <DateRangeCalendar 
        initialStartDate={dayjs(formatDateSubtractDays(new Date(), 0))} 
        initialEndDate={dayjs(formatDateSubtractDays(new Date(), 0))}
        onDateChange={handleDateRange}
      /> */}
      <Button
        variant="contained"
        color="main"
        startIcon={<AddIcon />}
        onClick={handleOpenUploadDlg2}
        // disabled={!rules.canEdit}
      >
        Add Attachment
      </Button>
    </Box>
    <Divider
      sx={{
        color: "text.disabled",
        "& .MuiDivider-wrapper": { px: 6 },
        fontSize: theme.typography.body2.fontSize,
        my: (theme) => `${theme.spacing(3)} !important`,
      }}
    />
    <div>
      {isAttachmentsLoading ? (
        <p>Loading attachments...</p>
      ) : (
        // Temporarily display attachments directly for testing
        <Timeline>
          {attachments.length === 0 ? (
           <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    mx: "auto",
    border: "1px solid #EAEAEA",
    borderRadius: 1,
    width: "100%",
    height: 280,
    py: 4,
    alignItems: "center" ,
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
      justifyContent: "center",
      alignItems: "center",
      width: { xs: "90%", sm: "100%" }, 
      maxWidth: 400, 
      px: 2,
      textAlign: "center" 
    }}
  >
                <img
                  src={AddEmployeeDoodle}
                  alt="Empty State"
                  style={{ width: "100px", height: "auto" }}
                />
                <Typography variant="h6">No attachments added yet</Typography>
              </Box>
            </Box>
          ) : (
            Object.entries(groupedAttachments).map(([date, items]) => {
              const createDate = new Date(date);
              const fromDate = new Date(startDate);
              const toDate = new Date(endDate);

              if (createDate >= fromDate && createDate <= toDate) {
                return (
                  <Fragment key={date}>
                    {/* <Typography variant="h5" sx={{ fontWeight: "bold" }}>{date}</Typography> */}
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: "bold",
                        fontSize: { xs: "1.125rem", sm: "1.25rem" },
                        mb: 2,
                      }}
                    >
                      {date}
                    </Typography>
                    {items.map((attachment, index) => {
                      const parsedDate = new Date(attachment.createDate);
                      const formattedTime = !isNaN(parsedDate.getTime())
                        ? format(parsedDate, "hh:mm a")
                        : "Unknown time";
                      const deleteAttachment = async (event) => {
                        event.stopPropagation(); // Prevents parent click handlers

                        MySwal.fire({
                          title: "<strong>Are you sure?</strong>",
                          html: `<span>This will permanently delete the attachment.</span>`,
                          showCancelButton: true,
                          confirmButtonText: "Yes, delete it!",
                          cancelButtonText: "No, keep it",
                          width: "390px",
                          padding: "1rem",
                          focusConfirm: false,
                          showCloseButton: true,
                          closeButtonHtml: "&times;",
                          customClass: {
                             popup: theme.palette.mode === 'dark' ? 'custom-swal-popup-dark' : 'custom-swal-popup',
          title: theme.palette.mode === 'dark' ? 'custom-swal-title-dark' : 'custom-swal-title',
          htmlContainer: 'custom-swal-html',
          confirmButton: 'custom-swal-confirm',
         cancelButton: theme.palette.mode === 'dark' ? 'custom-swal-cancel-dark' : 'custom-swal-cancel',
          closeButton: 'custom-swal-close'
                          },
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            try {
                              const token = localStorage.getItem("jwtToken");
                              const response = await fetch(
                                `${dev_baseUrl}/Media/delete/Attachment/Request/${request.requestID}/${attachment.mediaID}`,
                                {
                                  method: "DELETE",
                                  headers: {
                                    Authorization: `Bearer ${token}`,
                                  },
                                }
                              );
                              const data = await response.json();

                              if (response.ok && !data.isError) {
                                toast.success(
                                  data.message ||
                                    "Attachment deleted successfully.",
                                  {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                     theme: "light",
                                    style: {
                                      fontFamily: '"DM Sans", sans-serif',
                                      fontSize: '15px',
                                    },
                                  }
                                );
                                fetchAttachments(); // Refetch attachments after successful delete
                              } else {
                                toast.error(
                                  data.message ||
                                    "Failed to delete the attachment.",
                                  {
                                    position: "top-right",
                                    autoClose: 5000,
                                    hideProgressBar: true,
                                    closeOnClick: false,
                                    pauseOnHover: true,
                                    draggable: true,
                                    progress: undefined,
                                     theme: "light",
                                    style: {
                                      fontFamily: '"DM Sans", sans-serif',
                                      fontSize: '15px',
                                    },
                                  }
                                );
                                // setMessage(data.message || 'Failed to delete the attachment.');
                              }
                            } catch (error) {
                              // setMessage('An error occurred while deleting the attachment. Please try again.');
                              toast.error(
                                "An error occurred while deleting the attachment. Please try again.",
                                {
                                  position: "top-right",
                                  autoClose: 5000,
                                  hideProgressBar: true,
                                  closeOnClick: false,
                                  pauseOnHover: true,
                                  draggable: true,
                                  progress: undefined,
                                    theme: "light",
                                    style: {
                                      fontFamily: '"DM Sans", sans-serif',
                                      fontSize: '15px',
                                    },
                                }
                              );
                            }
                          }
                        });
                      };
                      return (
                        <TimelineItem key={attachment.mediaID || index}>
                          <TimelineSeparator>
                            <TimelineDot color="error" />
                            {index < items.length && <TimelineConnector />}
                          </TimelineSeparator>
                          <TimelineContent
                            sx={{
                              py: { xs: 1, sm: 2 },
                              "& svg": {
                                verticalAlign: "middle",
                                mx: { xs: 1, sm: 2 },
                                fontSize: { xs: "1rem", sm: "1.25rem" },
                              },
                            }}
                          >
                            {/* <Typography variant="caption" sx={{ color: "secondary", fontSize: "12px" }}>
                            {formattedTime} - {request.requestTitle}
                          </Typography> */}
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.secondary",
                                fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                                display: "block",
                                mb: 1,
                              }}
                            >
                              {formattedTime} - {request.requestTitle}
                            </Typography>
                              <Box
      sx={{
        px: { xs: 2, sm: 6 },
        py: { xs: 2, sm: 4 },
        mt: 2,
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        border: "1px solid #D9D9D9",
        borderRadius: 2,
        width: { xs: "100%", sm: "40%" }, // Full width on mobile
        gap: { xs: 2, sm: 0 }
      }}
    >
                              {/* {console.log(attachment)} */}
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  width: { xs: "100%", sm: "auto" },
                                }}
                              >
                                <img
                                  width={40}
                                  height={40}
                                  alt={attachment.fileName || "attachment"}
                                  loading="lazy"
                                  src={
                                    thumbnails[attachment.fileName] ||
                                    "/images/ImageLoader.gif"
                                  }
                                  style={{ objectFit: "cover" }}
                                />
                                <Typography
                                  variant="body2"
                                  sx={{
                                    ml: 2,
                                    fontSize: { xs: "0.875rem", sm: "1rem" },
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {attachment.fileName || ""}
                                </Typography>
                              </Box>
                              <OptionsMenu
                                iconButtonProps={{
                                  size: "small",
                                  sx: {
                                    color: "text.secondary",
                                    p: 0.3,
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: (theme) =>
                                        theme.palette.action.hover,
                                      borderRadius: "50%",
                                    },
                                  },
                                }}
                                options={[
                                  // 'View Attachment',
                                  // 'Download',
                                  {
                                    text: (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <Icon icon="tabler:download" />
                                        Download
                                      </Box>
                                    ),
                                    menuItemProps: {
                                      onClick: (e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        downloadAttachment(
                                          request.requestID,
                                          attachment.fileName
                                        );
                                      },
                                      sx: {
                                        color: "primary.main",
                                        "&:not(.Mui-focusVisible):hover": {
                                          color: "primary.main",
                                          backgroundColor: (theme) =>
                                            hexToRGBA(
                                              theme.palette.primary.main,
                                              0.08
                                            ),
                                        },
                                      },
                                    },
                                  },
                                  // 'Print',
                                  {
                                    text: (
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 2,
                                        }}
                                      >
                                        <Icon icon="tabler:trash" />
                                        Delete
                                      </Box>
                                    ),
                                    menuItemProps: {
                                      onClick: deleteAttachment,
                                      sx: {
                                        color: "error.main",
                                        "&:not(.Mui-focusVisible):hover": {
                                          color: "error.main",
                                          backgroundColor: (theme) =>
                                            hexToRGBA(
                                              theme.palette.error.main,
                                              0.08
                                            ),
                                        },
                                      },
                                      // disabled: !rules.canEdit,
                                    },
                                  },
                                ]}
                              />
                            </Box>
                          </TimelineContent>
                        </TimelineItem>
                      );
                    })}
                  </Fragment>
                );
              }
            })
          )}
        </Timeline>
      )}
    </div>

    <AttachmentUploadDialog
      open={openUploadDlg2}
      handleClose={handleCloseUploadDlg2}
      Title="Upload Attachment"
      files={uploadFiles2}
      btnLoader={btnLoader}
      // getRootProps =  {getRootProps}
      // getInputProps = {getInputProps}
      setUploadFiles={setUploadFiles2}
      setFiles={setUploadFiles2}
      setBtnLoader={setBtnLoader}
      navigate={navigate}
      entity="Request"
      payload={request}
      setOpenUploadDlg={setOpenUploadDlg2}
      fetchAttachments={fetchAttachments}
      attachments={attachments}
    />

    <PreAttachment Title="Upload Attachment" {...AttachmentProps} />

    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  </>
);
}

export default AttachmentsComponent;